import React, { useEffect, useRef } from 'react';
import './VideoPlayerModal.css';
import { VideoContent } from '../types/video';

interface VideoPlayerModalProps {
  video: VideoContent;
  onClose: () => void;
}

const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({ video, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const player = videoRef.current;
    if (player) {
      player.play().catch(() => {});
    }

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [video.video]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="video-player-overlay" onClick={onClose}>
      <div className="video-player-content" onClick={(e) => e.stopPropagation()}>
        <button className="video-player-close" onClick={onClose} aria-label="Close video">
          ×
        </button>
        <h2 className="video-player-title">{video.title}</h2>
        <video
          ref={videoRef}
          src={video.video}
          poster={video.image}
          className="video-player-element"
          controls
          autoPlay
          playsInline
        />
      </div>
    </div>
  );
};

export default VideoPlayerModal;
